import styled, { keyframes } from 'styled-components'

import { mq, sizes } from '../../theme'
import Icon from '../../components/Icon'

export const zoomFadeRondelle = keyframes`
  0% {
    opacity: 0;
    transform: scale(0) rotate(0deg);
  }

  16% {
    opacity: 1;
    transform: scale(1) rotate(180deg);
  }

  33% {
    opacity: 0;
    transform: scale(0) rotate(360deg);
  }

  100% {
    opacity: 0;
    transform: scale(0) rotate(0deg);
  }
`

export const zoomFadeBowling = keyframes`
  0% {
    opacity: 0;
    transform: scale(0) rotate(0deg);
  }

  33% {
    opacity: 0;
    transform: scale(0) rotate(0deg);
  }

  50% {
    opacity: 1;
    transform: scale(1) rotate(180deg);
  }

  66% {
    opacity: 0;
    transform: scale(0) rotate(360deg);
  }

  100% {
    opacity: 0;
    transform: scale(0) rotate(0deg);
  }
`

export const zoomFadeBaseball = keyframes`
  0% {
    opacity: 0;
    transform: scale(0) rotate(0deg);
  }

  66% {
    opacity: 0;
    transform: scale(0) rotate(0deg);
  }

  82% {
    opacity: 1;
    transform: scale(1) rotate(180deg);
  }

  100% {
    opacity: 0;
    transform: scale(0) rotate(360deg);
  }
`

export const Inner = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 2rem 0 6rem 0;
  position: relative;
`

export const Title = styled.span`
  ${({ theme }) => theme.textStyles.text_bold_18};
  text-align: center;

  @media ${mq(sizes.desktop)} {
    ${({ theme }) => theme.textStyles.text_bold_32};
  }
`

export const SubTitle = styled.span`
  ${({ theme }) => theme.textStyles.text_bold_16};
  text-align: center;

  @media ${mq(sizes.desktop)} {
    ${({ theme }) => theme.textStyles.text_bold_22};
  }
`

export const AnimationContainer = styled.div`
  display: flex;
  position: relative;
  width: 6rem;
  height: 6rem;
  align-items: center;
  margin: 3rem 0 3rem 0;
  justify-content: center;
`

export const GenerationIcon = styled(Icon)`
  display: block;
  position: absolute;
  justify-content: center;
  width: 4.5rem;
  height: 4.5rem;
  color: ${({ theme }) => theme.colors.greenApple};

  &.rondelle {
    animation: 4s ease-out infinite ${zoomFadeRondelle};
  }

  &.bowling {
    animation: 4s ease-out infinite ${zoomFadeBowling};
  }

  &.baseball {
    animation: 4s ease-out infinite ${zoomFadeBaseball};
  }

  @media ${mq(sizes.desktop)} {
    width: 5.5rem;
    height: 5.5rem;
  }
`

export const GeneratingMessage = styled.span`
  ${({ theme }) => theme.textStyles.text_16};
  text-align: center;

  @media ${mq(sizes.desktop)} {
    ${({ theme }) => theme.textStyles.text_18};
  }
`
export const ScrollInto = styled.div`
  position: absolute;
  top: -300px;
  pointer-events: none;
  height: 0;
  width: 0;
`
